export enum AuthErrorEnum {
  WRONG_PASSWORD = "auth/wrong-password",
  EMAIL_EXISTS = "auth/email-already-in-use",
}
